import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchReservations(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/reservation_vouchers/", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchReservation(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/reservation_vouchers/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editReservation(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/reservation_vouchers", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteReservation(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/reservation_vouchers", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
   
  }
};
